import { dateHR } from "utils/dates";
import { VerifiedTick } from "components/buttons";
import { Image } from "components";
import { routes } from "routes";

export const UserInfo = (props: {
  name?: string;
  gifId: string;
  userpic?: string;
  verified: boolean;
  createDate: number;
}): JSX.Element => {
  if (!props.name) {
    return <></>;
  }

  return (
    <div className="userInfo">
      <a
        href={routes.user(props.name)}
        title="Open user profile page"
        target="_blank"
        rel="noreferrer"
      >
        <Image className="userpic" src={props.userpic} />
      </a>

      <div className="text">
        <div className="date">
          <a
            href={routes.watch(props.gifId)}
            target="_blank"
            title="Open gif page"
            rel="noreferrer"
          >{dateHR(props.createDate)}</a>
        </div>
        <div className="author">
          <a
            href={routes.user(props.name)}
            target="_blank"
            title="Open user profile page"
            rel="noreferrer"
          >{props.name}</a>
          {props.verified && (
            <VerifiedTick hint="Video from a verified user" />
          )}
        </div>
      </div>
    </div>
  );
};
